let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3efDK")).then(() => parcelRequire('btnfh'));